module.exports = __webpack_public_path__ + "img/shangye_yujincheng_suoluetu.1d664829.png";